import React from "react";
import { Badge } from "@mui/material";

const NotificationBadge = ({ count, children, showZero = false }) => {
  // Don't show badge if count is 0 and showZero is false
  if (count === 0 && !showZero) {
    return children;
  }

  // Format count display (show 99+ for counts over 99)
  const displayCount = count > 99 ? "99+" : count.toString();

  return (
    <Badge
      badgeContent={displayCount}
      color="error"
      sx={{
        "& .MuiBadge-badge": {
          backgroundColor: "#FF4444",
          color: "white",
          fontSize: "11px",
          fontWeight: "bold",
          minWidth: "18px",
          height: "18px",
          borderRadius: "9px",
          right: -6,
          top: 2,
          fontFamily: "Avenir Book, sans-serif",
        },
      }}
    >
      {children}
    </Badge>
  );
};

export default NotificationBadge;
